import Component from "grimoirejs/ref/Node/Component";
import GLTFParser from "../Parser/Parser";
import DefaultInstanciator from "../Instanciator/DefaultInstanciator";
export default class GLTFModelComponent extends Component {
    constructor() {
        super(...arguments);
        this.jointMatrices = {};
        this.skeletons = {};
    }
    $mount() {
        const src = this.getAttribute("src");
        if (src) {
            const gl = this.companion.get("gl");
            const promise = GLTFParser.parseFromURL(gl, src).then((data) => {
                this.modelMeta = data.tf;
                GLTFModelComponent.instanciator.instanciateAll(data, this, this.getAttribute("scene"));
            });
            this.loadPromise = promise;
            if (this.getAttribute("waitForLoad")) {
                const loader = this.companion.get("loader");
                loader["register"](promise, this);
            }
        }
    }
    $update() {
    }
}
GLTFModelComponent.instanciator = new DefaultInstanciator();
GLTFModelComponent.componentName = "GLTFModelComponent";
GLTFModelComponent.attributes = {
    src: {
        converter: "String",
        default: null
    },
    scene: {
        converter: "String",
        default: null
    },
    waitForLoad: {
        converter: "Boolean",
        default: false
    },
    autoAnimate: {
        converter: "Boolean",
        default: true
    }
};



// WEBPACK FOOTER //
// ./src/Components/GLTFModelComponent.ts